import type { ComponentType } from 'react';

import type { UIFacet } from 'src/components/types/UIFacet';
import { FacetOptionsMulti } from './FacetOptionsMulti';
import { FacetOptionsSingle } from './FacetOptionsSingle';
import { customRenderers } from './facetRenderers';
import type { FacetOptionsProps } from './types';

export const resolveFacetOptionsComponent = (facet: UIFacet): ComponentType<FacetOptionsProps> =>
  customRenderers[facet.key] ?? (facet.type === 'single' ? FacetOptionsSingle : FacetOptionsMulti);
